const emailMessageOriginator = {
    EMAIL_RECEIVER : 'EMR',

    UPLOAD : 'UPLOAD',

    SEND : 'SEND'

};

angular.module('gw-um-j2js')
    .constant('emailMessageOriginator', emailMessageOriginator);